// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__2-6q1","sizeIconForMobile":"ProgressBar_sizeIconForMobile__2GJ0c","sizeIconForDesktop":"ProgressBar_sizeIconForDesktop__2c0fy"};